import { twMerge } from 'tailwind-merge';
import { priorityStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { PriorityValue } from '@/shared';

interface PriorityProps {
  value: PriorityValue;
  withLabel?: boolean;
}

const enumValues = Object.values(PriorityValue).filter(
  (value) => typeof value === 'number',
) as number[];

export const PriorityStatus = ({ value, withLabel }: PriorityProps) => {
  const { t } = useTranslation();
  const { bgColor, textColor } = priorityStyles(value);

  return (
    <div className="flex w-fit items-center gap-2">
      {withLabel && (
        <span className={twMerge('text-sm font-bold', textColor)}>
          {t(`priority_status_label_${PriorityValue[value]}`)}
        </span>
      )}
      <div className="flex w-min items-center gap-[1px]">
        {enumValues.map((_, index) => (
          <div
            key={index}
            className={twMerge(
              'h-[5px] w-2.5 bg-gray-100',
              index == 0 && 'rounded-l-full',
              index == enumValues.length - 1 && 'rounded-r-full',
              index <= value - 1 && bgColor,
            )}
          ></div>
        ))}
      </div>
    </div>
  );
};
